import { useSyncExternalStore } from 'react'
import { exportTracker, type TrackedExport } from '~/lib/export-tracker'

/** Exports suivis par l'onglet (`lib/export-tracker.ts`), relus à chaque changement du suivi. */
export const useTrackedExports = (): readonly TrackedExport[] =>
  useSyncExternalStore(exportTracker.subscribe, exportTracker.getSnapshot)
